export const BASE_URL = 'workflow-template';

export const WORKFLOW_AGENT_STEP_ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;

// Written out rather than derived from convertFileTypeSpecifiersToAcceptObject, which omits .md,
// .rtf, .xlsm, .xlsb and .ods and includes .csv — a file the server refuses. The UI must never
// advertise more than the server accepts.
//
// The server's dispatch is asymmetric: PDFs and spreadsheets are matched on extension, while
// doc/docx/rtf/txt/md are matched on the browser-supplied MIME type. Both forms are listed so the file
// picker offers the right files either way.
export const WORKFLOW_AGENT_STEP_ATTACHMENT_ACCEPT = [
  'application/pdf',
  '.pdf',
  'application/msword',
  '.doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.docx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.xlsx',
  'application/vnd.ms-excel',
  '.xls',
  '.xlsm',
  '.xlsb',
  'application/vnd.oasis.opendocument.spreadsheet',
  '.ods',
  'application/rtf',
  '.rtf',
  'text/plain',
  '.txt',
  'text/markdown',
  '.md',
].join(',');

/** Every extension the server can actually read. `.csv` is absent because it matches nothing. */
export const WORKFLOW_AGENT_STEP_ATTACHMENT_EXTENSIONS = new Set([
  'pdf',
  'doc',
  'docx',
  'xlsx',
  'xls',
  'xlsm',
  'xlsb',
  'ods',
  'rtf',
  'txt',
  'md',
]);

/** The reason the server refused, for a caller that shows it to a person.
 *
 * Nest sends `{ message, error, statusCode }`; `message` is a string for a thrown exception and an array
 * for a failed validation pipe. Returning undefined rather than a placeholder lets the caller keep its own
 * wording when the body says nothing useful. The response is cloned so the caller can still read it. */
export async function readErrorMessage(
  res: Response
): Promise<string | undefined> {
  try {
    const body = (await res.clone().json()) as { message?: string | string[] };
    const message = Array.isArray(body?.message)
      ? body.message.join('. ')
      : body?.message;

    return typeof message === 'string' && message.trim()
      ? message.trim()
      : undefined;
  } catch {
    return undefined;
  }
}
